var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 14,
  viewBox: "0 0 16 14",
  fill: "none",
  color: "#3B3B3B",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 6.5a5.5 5.5 0 0 1 8.25-4.763.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14 6.5a.5.5 0 0 0-1 0 5.5 5.5 0 0 1-11 0Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.854 1.855a.501.501 0 1 0-.708-.708L7.5 7.794 4.854 5.147a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7Z",
  fill: "currentColor"
})));
export default SvgCheck;